import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function FeeStructure() { 
  useEffect(() => {
    document.title = 'Fee Structure -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li> Admission </li>
                <li>Fee Structure</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Fee Structure</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
               <div className="housebox">
               <div className="accordion" id="accordionExample">
               <div className="accordion-item">
               <h2 className="accordion-header" id="headingOne">
               <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                    Fee Structure 2025-2026
               </button>
               </h2>
               <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
               <div className="accordion-body">
                      <div className="table-responsive">
                            <table className="table maintable">
                                 <thead>
                                    <tr>
                                       <th> Classes </th> 
                                       <th> April - May     </th>
                                       <th> June-July   </th>
                                       <th> Aug - Sept </th>
                                       <th>  Oct - Nov  </th> 
                                       <th>  Dec - Jan   </th> 
                                       <th> Feb - Mar </th> 
                                   </tr>
                                 </thead> 
                                  <tbody>
                                           <tr>
                                               <td><strong>PG</strong></td>
                                               <td>9800</td>
                                               <td>9800</td>
                                               <td>9800</td>
                                               <td>9800</td>
                                               <td>9800</td>
                                               <td>9800</td>
                                           </tr>
                                           <tr>
                                               <td><strong>NUR</strong></td>
                                               <td>9800</td>
                                               <td>9800</td>
                                               <td>9800</td>
                                               <td>9800</td>
                                               <td>9800</td>
                                               <td>9800</td>
                                           </tr>
                                           <tr>
                                               <td><strong>PREP</strong></td>
                                               <td>9800</td>
                                               <td>9800</td>
                                               <td>9800</td>
                                               <td>9800</td>
                                               <td>9800</td>
                                               <td>9800</td>
                                           </tr>
                                           <tr>
                                               <td><strong>I</strong></td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                           </tr>
                                           <tr>
                                               <td><strong>II</strong></td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                           </tr>
                                           <tr>
                                               <td><strong>III</strong></td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                           </tr>
                                           <tr>
                                               <td><strong>IV</strong></td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                           </tr>
                                           <tr>
                                               <td><strong>V</strong></td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                               <td>10,000</td>
                                           </tr>
                                           <tr>
                                               <td><strong>VI</strong></td>
                                               <td>10,200</td>
                                               <td>10,200</td>
                                               <td>10,200</td>
                                               <td>10,200</td>
                                               <td>10,200</td>
                                               <td>10,200</td>
                                           </tr>
                                           <tr>
                                               <td><strong>VII</strong></td>
                                               <td>10,200</td>
                                               <td>10,200</td>
                                               <td>10,200</td>
                                               <td>10,200</td>
                                               <td>10,200</td>
                                               <td>10,200</td>
                                           </tr>
                                           <tr>
                                               <td><strong>VIII</strong></td>
                                               <td>10,200</td>
                                               <td>10,200</td>
                                               <td>10,200</td>
                                               <td>10,200</td>
                                               <td>10,200</td>
                                               <td>10,200</td>
                                           </tr>
                                           <tr>
                                               <td><strong>IX</strong></td>
                                               <td>11,400</td>
                                               <td>11,400</td>
                                               <td>11,400</td>
                                               <td>11,400</td>
                                               <td>11,400</td>
                                               <td>11,400</td>
                                           </tr>
                                           <tr>
                                               <td><strong>X</strong></td>
                                               <td>11,400</td>
                                               <td>11,400</td>
                                               <td>11,400</td>
                                               <td>11,400</td>
                                               <td>11,400</td>
                                               <td>11,400</td>
                                           </tr>
                                           <tr>
                                           <td colspan="7"><strong>XI</strong></td>
                                               
                                           </tr>
                                           <tr>
                                               <td><strong>With Computer</strong></td>
                                               <td>14,200</td>
                                               <td>14,200</td>
                                               <td>14,200</td>
                                               <td>14,200</td>
                                               <td>14,200</td>
                                               <td>14,200</td>
                                           </tr>
                                           <tr>
                                               <td><strong>Without Computer</strong></td>
                                               <td>13,400</td>
                                               <td>13,400</td>
                                               <td>13,400</td>
                                               <td>13,400</td>
                                               <td>13,400</td>
                                               <td>13,400</td>
                                           </tr>
                                           <tr>
                                               <td><strong>Commerce</strong></td>
                                               <td>12,000</td>
                                               <td>12,000</td>
                                               <td>12,000</td>
                                               <td>12,000</td>
                                               <td>12,000</td>
                                               <td>12,000</td>
                                           </tr>
                                           <tr>
                                               <td colspan="7"><strong>XII</strong></td>
                                                
                                           </tr>
                                           <tr>
                                               <td><strong>With Computer</strong></td>
                                               <td>14,200</td>
                                               <td>14,200</td>
                                               <td>14,200</td>
                                               <td>14,200</td>
                                               <td>14,200</td>
                                               <td>14,200</td>
                                           </tr>
                                           <tr>
                                               <td><strong>Without Computer</strong></td>
                                               <td>13,400</td>
                                               <td>13,400</td>
                                               <td>13,400</td>
                                               <td>13,400</td>
                                               <td>13,400</td>
                                               <td>13,400</td>
                                           </tr>
                                           <tr>
                                               <td><strong>Commerce</strong></td>
                                               <td>12,000</td>
                                               <td>12,000</td>
                                               <td>12,000</td>
                                               <td>12,000</td>
                                               <td>12,000</td>
                                               <td>12,000</td>
                                           </tr>
                                       </tbody>
                            </table>
                     </div>
               </div>
               </div>
               </div>
                 <div className="accordion-item">
                              <h2 className="accordion-header" id="headingOne">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                     Fee Structure 2021-2022
                                </button>
                              </h2>
                              <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                       <div className="table-responsive">
                                             <table className="table maintable">
                                                  <thead>
                                                  <tr>
                                                  <th rowspan="2">HEADS</th>
                                                  <th rowspan="2">I - V</th>
                                                  <th rowspan="2">VI - VII</th>
                                                  <th rowspan="2">IX - X</th>
                                                  <th>XI - XII</th>
                                                  <th>XI - XII</th>
                                                  <th>XI - XII</th>
                                                  </tr>
                                                  <tr>
                                                  <th>COMMERCE</th>
                                                  <th>WITHOUT COMPUTER</th>
                                                  <th>WITH COMPUTER</th>
                                                  </tr>
                                                  </thead>
                                                  <tbody>
                                                 
                                                  <tr>
                                                  <td><strong>April  2021</strong></td>
                                                  <td>3600</td>
                                                  <td>3700</td>
                                                  <td>4200</td>
                                                  <td>4500</td>
                                                  <td>4875</td>
                                                  <td>5300</td>
                                                  </tr>
                                                  <tr>
                                                  <td><strong>May 2021</strong></td>
                                                  <td>3600</td>
                                                  <td>3700</td>
                                                  <td>4200</td>
                                                  <td>4500</td>
                                                  <td>4875</td>
                                                  <td>5300</td>
                                                  </tr>
                                                  <tr>
                                                  <td><strong>June 2021</strong></td>
                                                  <td>3600</td>
                                                  <td>3700</td>
                                                  <td>4200</td>
                                                  <td>4500</td>
                                                  <td>4875</td>
                                                  <td>5300</td>
                                                  </tr>
                                                  <tr>
                                                  <td><strong>July 2021</strong></td>
                                                  <td>3600</td>
                                                  <td>3700</td>
                                                  <td>4200</td>
                                                  <td>4500</td>
                                                  <td>4875</td>
                                                  <td>5300</td>
                                                  </tr>
                                                  <tr>
                                                  <td><strong>Aug 2021</strong></td>
                                                  <td>3600</td>
                                                  <td>3700</td>
                                                  <td>4200</td>
                                                  <td>4500</td>
                                                  <td>4875</td>
                                                  <td>5300</td>
                                                  </tr>
                                                  <tr>
                                                  <td><strong> Sept 2021</strong></td>
                                                  <td>3600</td>
                                                  <td>3700</td>
                                                  <td>4200</td>
                                                  <td>4500</td>
                                                  <td>4875</td>
                                                  <td>5300</td>
                                                  </tr>
                                                  <tr>
                                                  <td><strong>Oct 2021</strong></td>
                                                  <td>3600</td>
                                                  <td>3700</td>
                                                  <td>4200</td>
                                                  <td>4500</td>
                                                  <td>4875</td>
                                                  <td>5300</td>
                                                  </tr>
                                                  <tr>
                                                  <td><strong> Nov 2021</strong></td>
                                                  <td>3600</td>
                                                  <td>3700</td>
                                                  <td>4200</td>
                                                  <td>4500</td>
                                                  <td>4875</td>
                                                  <td>5300</td>
                                                  </tr>
                                                  <tr>
                                                  <td><strong>Dec 2021</strong></td>
                                                  <td>3600</td>
                                                  <td>3700</td>
                                                  <td>4200</td>
                                                  <td>4500</td>
                                                  <td>4875</td>
                                                  <td>5300</td>
                                                  </tr>
                                                  <tr>
                                                  <td><strong>Jan 2022</strong></td>
                                                  <td>3600</td>
                                                  <td>3700</td>
                                                  <td>4200</td>
                                                  <td>4500</td>
                                                  <td>4875</td>
                                                  <td>5300</td>
                                                  </tr>
                                                  <tr>
                                                  <td><strong>Feb  2022</strong></td>
                                                  <td>3600</td>
                                                  <td>3700</td>
                                                  <td>4200</td>
                                                  <td>4500</td>
                                                  <td>4875</td>
                                                  <td>5300</td>
                                                  </tr>
                                                  <tr>
                                                  <td><strong>March 2022</strong></td>
                                                  <td>3600</td>
                                                  <td>3700</td>
                                                  <td>4200</td>
                                                  <td>4500</td>
                                                  <td>4875</td>
                                                  <td>5300</td>
                                                  </tr>
                                                  <tr>
                                                  <td><strong>Total</strong></td>
                                                  <td><strong>43200</strong></td>
                                                  <td><strong>44400</strong></td>
                                                  <td><strong>50400</strong></td>
                                                  <td><strong>54000</strong></td>
                                                  <td><strong>58500</strong></td>
                                                  <td><strong>63600</strong></td>
                                                  </tr>
                                                  </tbody> 
                                             </table>
                                      </div>
                                </div>
                              </div>
                            </div>
                          <div className="accordion-item">
                              <h2 className="accordion-header" id="headingTwo">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    Fee Structure 2020-2021
                                </button>
                              </h2>
                              <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                       <div className="table-responsive">
                                             <table className="table maintable">
                                                       <thead>
                                                         <tr>
                                                          <th rowspan="2">HEADS</th>
                                                          <th rowspan="2">I - V</th>
                                                          <th rowspan="2">VI - VII</th>
                                                          <th rowspan="2">IX - X</th>
                                                          <th>XI - XII</th>
                                                          <th>XI - XII</th>
                                                          <th>XI - XII</th>
                                                        </tr>
                                                        <tr>
                                                          <th>COMMERCE</th>
                                                          <th>WITHOUT COMPUTER</th>
                                                          <th>WITH COMPUTER</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        
                                                        <tr>
                                                          <td><strong>April  2020</strong></td>
                                                          <td>3550</td>
                                                          <td>3650</td>
                                                          <td>4200</td>
                                                          <td>4500</td>
                                                          <td>4875</td>
                                                          <td>5275</td>
                                                        </tr>
                                                        <tr>
                                                          <td><strong>May 2020</strong></td>
                                                          <td>3550</td>
                                                          <td>3650</td>
                                                          <td>4200</td>
                                                          <td>4500</td>
                                                          <td>4875</td>
                                                          <td>5275</td>
                                                        </tr>
                                                        <tr>
                                                          <td><strong>June 2020</strong></td>
                                                          <td>3550</td>
                                                          <td>3650</td>
                                                          <td>4200</td>
                                                          <td>4500</td>
                                                          <td>4875</td>
                                                          <td>5275</td>
                                                        </tr>
                                                        <tr>
                                                          <td><strong>July 2020</strong></td>
                                                          <td>3550</td>
                                                          <td>3650</td>
                                                          <td>4200</td>
                                                          <td>4500</td>
                                                          <td>4875</td>
                                                          <td>5275</td>
                                                        </tr>
                                                        <tr>
                                                          <td><strong>Aug 2020</strong></td>
                                                          <td>3550</td>
                                                          <td>3650</td>
                                                          <td>4200</td>
                                                          <td>4500</td>
                                                          <td>4875</td>
                                                          <td>5275</td>
                                                        </tr>
                                                        <tr>
                                                          <td><strong> Sept 2020</strong></td>
                                                          <td>3550</td>
                                                          <td>3650</td>
                                                          <td>4200</td>
                                                          <td>4500</td>
                                                          <td>4875</td>
                                                          <td>5275</td>
                                                        </tr>
                                                        <tr>
                                                          <td><strong>Oct 2020</strong></td>
                                                          <td>3550</td>
                                                          <td>3650</td>
                                                          <td>4200</td>
                                                          <td>4500</td>
                                                          <td>4875</td>
                                                          <td>5275</td>
                                                        </tr>
                                                        <tr>
                                                          <td><strong> Nov 2020</strong></td>
                                                          <td>3550</td>
                                                          <td>3650</td>
                                                          <td>4200</td>
                                                          <td>4500</td>
                                                          <td>4875</td>
                                                          <td>5275</td>
                                                        </tr>
                                                        <tr>
                                                          <td><strong>Dec 2020</strong></td>
                                                          <td>3550</td>
                                                          <td>3650</td>
                                                          <td>4200</td>
                                                          <td>4500</td>
                                                          <td>4875</td>
                                                          <td>5275</td>
                                                        </tr>
                                                        <tr>
                                                          <td><strong>Jan 2021</strong></td>
                                                          <td>3550</td>
                                                          <td>3650</td>
                                                          <td>4200</td>
                                                          <td>4500</td>
                                                          <td>4875</td>
                                                          <td>5275</td>
                                                        </tr>
                                                        <tr>
                                                          <td><strong>Feb  2021</strong></td>
                                                          <td>3550</td>
                                                          <td>3650</td>
                                                          <td>4200</td>
                                                          <td>4500</td>
                                                          <td>4875</td>
                                                          <td>5275</td>
                                                        </tr>
                                                        <tr>
                                                          <td><strong>March 2021</strong></td>
                                                          <td>3550</td>
                                                          <td>3650</td>
                                                          <td>4200</td>
                                                          <td>4500</td>
                                                          <td>4875</td>
                                                          <td>5275</td>
                                                        </tr>
                                                        <tr>
                                                          <td><strong>Total</strong></td>
                                                          <td><strong>42600</strong></td>
                                                          <td><strong>43800</strong></td>
                                                          <td><strong>50400</strong></td>
                                                          <td><strong>54000</strong></td>
                                                          <td><strong>58500</strong></td>
                                                          <td><strong>63300</strong></td>
                                                        </tr>
                                                      </tbody>  
                                             </table>
                                      </div>
                                </div>
                              </div>
                            </div>
                          <div className="accordion-item">
                                  <h2 className="accordion-header" id="headingThree">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                       Fee Structure 2019-2020
                                    </button>
                                  </h2>
                                  <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                           <div className="table-responsive">
                                                 <table className="table maintable">
                                                          <thead>
                                                          <tr>
                                                <th rowspan="2">HEADS</th>
                                                <th rowspan="2">I - V</th>
                                                <th rowspan="2">VI - VII</th>
                                                <th rowspan="2">IX - X</th>
                                                <th>XI - XII</th>
                                                <th>XI - XII</th>
                                                <th>XI - XII</th>
                                              </tr>
                                              <tr>
                                              <th>COMMERCE</th>
                                              <th>WITHOUT COMPUTER</th>
                                              <th>WITH COMPUTER</th>
                                            </tr>
                                              </thead>
                                              <tbody>
                                             
                                              <tr>
                                                <td><strong>April &amp; May 2019</strong></td>
                                                <td>7100</td>
                                                <td>7300</td>
                                                <td>8400</td>
                                                <td>9000</td>
                                                <td>9750</td>
                                                <td>10550</td>
                                              </tr>
                                              <tr>
                                                <td><strong>June &amp; July 2019</strong></td>
                                                <td>7100</td>
                                                <td>7300</td>
                                                <td>8400</td>
                                                <td>9000</td>
                                                <td>9750</td>
                                                <td>10550</td>
                                              </tr>
                                              <tr>
                                                <td><strong>Aug &amp; Sept 2019</strong></td>
                                                <td>7100</td>
                                                <td>7300</td>
                                                <td>8400</td>
                                                <td>9000</td>
                                                <td>9750</td>
                                                <td>10550</td>
                                              </tr>
                                              <tr>
                                                <td><strong>Oct &amp; Nov 2019</strong></td>
                                                <td>7100</td>
                                                <td>7300</td>
                                                <td>8400</td>
                                                <td>9000</td>
                                                <td>9750</td>
                                                <td>10550</td>
                                              </tr>
                                              <tr>
                                                <td><strong>Dec &amp; Jan 2019</strong></td>
                                                <td>7100</td>
                                                <td>7300</td>
                                                <td>8400</td>
                                                <td>9000</td>
                                                <td>9750</td>
                                                <td>10550</td>
                                              </tr>
                                              <tr>
                                                <td><strong>Feb &amp; March 2020</strong></td>
                                                <td>7100</td>
                                                <td>7300</td>
                                                <td>8400</td>
                                                <td>9000</td>
                                                <td>9750</td>
                                                <td>10550</td>
                                              </tr>
                                              <tr>
                                                <td><strong>Total</strong></td>
                                                <td><strong>42600</strong></td>
                                                <td><strong>43800</strong></td>
                                                <td><strong>50400</strong></td>
                                                <td><strong>54000</strong></td>
                                                <td><strong>58500</strong></td>
                                                <td><strong>63300</strong></td>
                                              </tr>
                                            </tbody>
                                                 </table>
                                          </div>
                                    </div>
                                  </div>
                                </div>
                          <div className="accordion-item">
              <h2 className="accordion-header" id="headingFour">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                    Fee Structure 2018-2019
                </button>
              </h2>
              <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                <div className="accordion-body">
                       <div className="table-responsive">
                             <table className="table maintable">
                                  <thead>
                                  <tr>
                                  <th rowspan="2">HEADS</th>
                                  <th rowspan="2">I - V</th>
                                  <th rowspan="2">VI - VII</th>
                                  <th rowspan="2">IX - X</th>
                                  <th>XI - XII</th>
                                  <th>XI - XII</th>
                                  <th>XI - XII</th>
                                  </tr>
                                  <tr>
                                  <th>COMMERCE</th>
                                  <th>WITHOUT COMPUTER</th>
                                  <th>WITH COMPUTER</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                 
                                  <tr>
                                  <td><strong>April &amp; May 2018</strong></td>
                                  <td>6600</td>
                                  <td>6800</td>
                                  <td>7800</td>
                                  <td>8300</td>
                                  <td>8950</td>
                                  <td>9550</td>
                                  </tr>
                                  <tr>
                                  <td><strong>June &amp; July 2018</strong></td>
                                  <td>6600</td>
                                  <td>6800</td>
                                  <td>7800</td>
                                  <td>8300</td>
                                  <td>8950</td>
                                  <td>9550</td>
                                  </tr>
                                  <tr>
                                  <td><strong>Aug &amp; Sept 2018</strong></td>
                                  <td>6600</td>
                                  <td>6800</td>
                                  <td>7800</td>
                                  <td>8300</td>
                                  <td>8950</td>
                                  <td>9550</td>
                                  </tr>
                                  <tr>
                                  <td><strong>Oct &amp; Nov 2018</strong></td>
                                  <td>6600</td>
                                  <td>6800</td>
                                  <td>7800</td>
                                  <td>8300</td>
                                  <td>8950</td>
                                  <td>9550</td>
                                  </tr>
                                  <tr>
                                  <td><strong>Dec &amp; Jan 2019</strong></td>
                                  <td>6600</td>
                                  <td>6800</td>
                                  <td>7800</td>
                                  <td>8300</td>
                                  <td>8950</td>
                                  <td>9550</td>
                                  </tr>
                                  <tr>
                                  <td><strong>Feb &amp; March 2019</strong></td>
                                  <td>6600</td>
                                  <td>6800</td>
                                  <td>7800</td>
                                  <td>8300</td>
                                  <td>8950</td>
                                  <td>9550</td>
                                  </tr>
                                  <tr>
                                  <td><strong>Total</strong></td>
                                  <td><strong>39600</strong></td>
                                  <td><strong>40800</strong></td>
                                  <td><strong>46800</strong></td>
                                  <td><strong>49800</strong></td>
                                  <td><strong>53700</strong></td>
                                  <td><strong>57300</strong></td>
                                  </tr>
                                  </tbody>         
                            </table>
                       </div>
                </div>
          </div>
      </div>
  </div>
</div>
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default FeeStructure;
